import { useEffect, useState } from 'react';
import NavItem from './NavItem';

import './NavBar.css';

const routes = [
  {
    to: '/',
    title: 'Inicio',
    isActive: true,
  },
  {
    to: '/about',
    title: 'Sobre mi',
    isActive: false,
  },
  {
    to: '/skills',
    title: 'Tecnologías',
    isActive: false,
  },
  {
    to: '/projects',
    title: 'Proyectos',
    isActive: false,
  },
  {
    to: '/contact',
    title: 'Contacto',
    isActive: false,
  },
];

const NavBar = () => {
  const [navFade, setNavFade] = useState({
    fade: 'fade-out',
    position: 'from-bottom',
  });

  useEffect(() => {
    const timeout = setInterval(() => {
      if (navFade.fade === 'fade-out') {
        setNavFade({
          fade: 'fade-in',
          position: 'center',
        });
      }
    }, 1500);
    return () => clearInterval(timeout);
  }, [navFade]);

  return (
    <nav className={`navbar ${navFade.fade} ${navFade.position}`}>
      <ul>
        {routes.map((route, key) => {
          return (
            <NavItem
              key={key}
              goTo={route.to}
              title={route.title}
              isActive={route.isActive}
            />
          );
        })}
      </ul>
    </nav>
  );
};

export default NavBar;
